import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tailwind.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/main.scss';
// Initialize Firebase (analytics and performance monitoring)
import './firebase';
import { logError } from './firebase';

// Global error handler for unhandled errors
window.addEventListener('error', (event) => {
  logError(event.error || new Error(event.message), {
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

// Global handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  logError(
    event.reason instanceof Error 
      ? event.reason 
      : new Error(String(event.reason)),
    { type: 'unhandledrejection' }
  );
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
